export const FIXTURE_MATCH_DATE = 'EEEE d MMMM y';
export const FIXTURE_MATCH_TIME = 'HH:mm';
